import React from 'react';

import { App } from 'generated/graphql';

import { Hero } from 'components/NoMenus/Hero';
import { ImageAndText } from 'components/NoMenus/ImageAndText';
import { SupportedApps } from 'components/NoMenus/SupportedApps';

import styles from 'components/NoMenus/NoMenus.module.scss';

import grapefruit from 'lotties/grapefruit.json';
import mint from 'lotties/mint.json';
import oyster from 'lotties/oyster.json';

interface Props {
  isAbout?: boolean;
  venueId?: string;
  supportedApps: App[];
}

const NoMenus: React.FC<Props> = ({ isAbout, supportedApps, venueId }) => {
  return (
    <div className={styles.NoMenus} data-testid="nomenus">
      <Hero apps={supportedApps} isAbout={isAbout} venueId={venueId} />
      <div className={styles.ImageAndTextCont}>
        <ImageAndText
          title="Less double handling"
          copy="View and manage your venue’s online menus across a range of Pickup & Delivery and In-Venue Ordering apps, in one place. More time to do what you do best."
          imageSrc="/Images/nomenus-image1.png"
          venueId={venueId}
          lottieData={oyster}
        />
        <ImageAndText
          title="Mistakes served rare"
          copy="Update item availability in one click across all your apps during service. Less cancelled orders means more happy customers."
          imageSrc="/Images/nomenus-image2.png"
          venueId={venueId}
          lottieData={grapefruit}
          reverse
        />
        <ImageAndText
          title="Menu updates, pronto!"
          copy="Use our simple tools to update your menu items in a flash and perfect your pricing."
          imageSrc="/Images/nomenus-image3.png"
          venueId={venueId}
          lottieData={mint}
        />
      </div>
      <SupportedApps apps={supportedApps} venueId={venueId} />
    </div>
  );
};

export default NoMenus;
